import { PaymentTypeEnum } from '../../../enumns/paymentType'
import { useExpertQuery } from '../../../services/hooks/experts/queries/useExpertQuery'

export const useIsRegistrationIncomplete = (userId: number) => {
  const { data: expert, isLoading } = useExpertQuery(userId)

  const expertNoPaymentType = expert?.paymentType === PaymentTypeEnum.NO_PAYMENT

  const hasPersonDataRegistered = (() => {
    switch (expert?.personType) {
      case 'legal_person':
        return !!expert?.legalData && !!expert?.cpf
      case 'natural_person':
        return !!expert?.naturalData && !!expert?.cpf
      case 'international_person':
        return !!expert?.phone
      default:
        return false
    }
  })()

  const hasBankDataRegistered = (() => {
    if (expert?.personType === 'international_person') {
      return (
        !!expert?.bankData?.swiftCode &&
        !!expert?.bankData?.bankAccountNumber &&
        !!expert?.bankData?.internationalBankBranch &&
        !!expert?.bankData?.amazonGiftCardEmail
      )
    } else {
      const hasBankDetails =
        !!expert?.bankData?.bank &&
        !!expert?.bankData?.bankBranch &&
        !!expert?.bankData?.currentAccount

      const hasPix = !!expert?.bankData?.pix

      return hasBankDetails || hasPix
    }
  })()

  const isRegistrationIncomplete =
    !(hasPersonDataRegistered && hasBankDataRegistered) && !expertNoPaymentType && !isLoading

  return isRegistrationIncomplete
}
